/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var InsuranceBundle;

(function (InsuranceBundle) {
  InsuranceBundle["ALL"] = "all";
  InsuranceBundle["ONLY_GIT"] = "only_git";
  InsuranceBundle["PL_GL_ONLY"] = "pl_gl_only";
  InsuranceBundle["PL_BOP_CYBER"] = "pl_bop_cyber";
})(InsuranceBundle || (InsuranceBundle = {}));